import React from "react";
import {
  Button,
  ListItem,
  Popper,
  Paper,
  MenuList,
  MenuItem,
  Grow
} from "@mui/material";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { atlanticColor, orangePeelColor } from "assets/jss/material-dashboard-pro-react";

export default function AuthDropDown({ classes }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleEnter = () => setOpen(true);
  const handleLeave = () => setOpen(false);

  return (
    <ListItem
      className={classes.listItem}
      ref={anchorRef}
      sx={{ position: "relative" }}
    >
      <Button
        classes={{ root: classes.listButton }}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        color="secondary"
        endIcon={<ExpandMoreIcon />}
      >
        Company
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom"
        transition
        style={{ zIndex: 1300 }}
        modifiers={[ 
            { 
                name: "offset", 
                options: { 
                    offset: [0, -20] 
                } 
            } 
        ]}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} timeout={200}>
            <Paper 
            onMouseEnter={handleEnter} 
            onMouseLeave={handleLeave}
            style={{ backgroundColor: "#fbfaf8", color: atlanticColor[0], borderRadius: "2px"}}>
              <MenuList
              style={{
                paddingBottom: "0px",
                paddingTop: "0px"
              }}>
                <MenuItem 
                component={Link} 
                to="/about" 
                >
                  About
                </MenuItem>

                <MenuItem 
                component={Link} 
                to="/contact-us"
                >
                  Contact Us
                </MenuItem>
              </MenuList>
            </Paper>
          </Grow>
        )}
      </Popper>
    </ListItem>
  );
}